MS = window.MS || {};
(function($) {
  MS.hero = {
    selectors: {
      section: '.ms-pl-hero',
      background: '.ms-pl-hero__background',
      withText: '.ms-pl-hero--with-text',
      scroller: '.ms-ts-hero__scroll',
      title: '.ms-pl-hero__headline',
      cta: '.ms-pl-hero__cta',
      animated: '.ms-pl-hero--animated',
      ctaAnchor: '.ms-pl-hero__cta--anchor',
      benefitModule: '.ms-pl-benefit',
      benefitModuleItem: '.ms-pl-benefit__item'
    },

    init: function() {
      var _this = this;

      this.$module = $(this.selectors.section);
      this.$wrapper = $(this.selectors.wrapper);
      this.$source = $('img' + this.selectors.background, this.$module);
      this.$background = $('div' + this.selectors.background, this.$module);
      this.$scroller = $(this.selectors.scroller, this.$module);
      this.$heroTitle = $(this.selectors.title);
      this.$cta = $(this.selectors.cta, this.$module);
      this.$ctaAnchor = $(this.selectors.ctaAnchor, this.$module);
      this.$benefitModule = $(this.selectors.benefitModule);
      this.targetPosOffset = 60;
      this.benefitItemPosArray = [];

      if (this.$benefitModule.length > 0) {
        this.$benefitModuleItems = $(this.selectors.benefitModuleItem);
      }

      this.handleAnimation();
      this.handleCTA();

      setTimeout(function() {
        _this.getBenefitsItemPosition();
        _this.checkScrollerPosition();
      }, 1200);

    },

    getBenefitsItemPosition: function() {
      var _this = this;

      _this.benefitItemPosArray = [];
      _this.$benefitModuleItems.each(function(i, ele) {
        _this.benefitItemPosArray.push(parseInt(ele.getBoundingClientRect().top) + window.pageYOffset);
      });

    },

    handleAnimation: function() {
      var image = new Image();
      var src = this.$source.attr('src');
      var _this = this;

      if(_this.$module.hasClass(_this.selectors.animated.replace('.',''))) {
        image.onload = function () {
          _this.$module.addClass(_this.selectors.withText.replace('.', ''));
          _this.$background.css('background-image', 'url(' + src + ')');
          _this.$cta.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(event) {
            _this.checkScrollerPosition();
          });
        }
        image.src = src;
      } else {
        _this.$background.css('background-image', 'url(' + src + ')');
      }

      window.addEventListener('scroll', utilities.debounce( function() {
        _this.checkScrollerPosition();
      }, 200));

      window.addEventListener('resize', utilities.debounce( function() {
        _this.getBenefitsItemPosition();
      }, 200));

      _this.$scroller.on('click', function() {
        var $parent = $(this).parents(_this.selectors.section).first();
        // get next module
        var _target = $parent.next().offset().top;

        if (_this.$benefitModule.length > 0) {
          var winScrollY = window.scrollY;

          // get the next item within the benefit Module
          for (i = 0; i < _this.benefitItemPosArray.length; i++) {
            if (winScrollY < _this.benefitItemPosArray[i] - (_this.targetPosOffset + 1)) {
              _target = _this.benefitItemPosArray[i] - _this.targetPosOffset;
              // hide scroll button when scroller has reached the last benefit item
              if (i === _this.benefitItemPosArray.length - 1) {
                  _this.$scroller.removeClass('is-animate').removeClass('is-visible');
              }
              break;
            }
          }

        }

        $("html, body").animate({ scrollTop: _target }, 800);
        _this.$scroller.removeClass('is-animate');

        setTimeout(function() {
          if( $(window).scrollTop() < _this.benefitItemPosArray[_this.benefitItemPosArray.length - 1] -  (_this.targetPosOffset + 10)) {
            _this.$scroller.addClass('is-animate');
          }
        }, 800);
      });
    },

    checkScrollerPosition: function() {
      var _this = this;
      var posOffset = _this.benefitItemPosArray[_this.benefitItemPosArray.length - 1] -  (_this.targetPosOffset + 10);

      if ( $(window).scrollTop() <= posOffset ) {
        this.$scroller.addClass('is-animate').addClass('is-visible');
      } else {
        this.$scroller.removeClass('is-animate').removeClass('is-visible');
      }
    },

    handleCTA: function() {
      if( this.$ctaAnchor.length > 0 ) {
        var _this = this;
        this.$ctaAnchor.on('click', function(e){
          e.preventDefault();
          var $target = $(_this.$ctaAnchor.attr('href'));
          $([document.documentElement, document.body]).animate({
            scrollTop: $target.offset().top - 100
        }, 900);
        });
      }
    }

  };
})(jQuery);
